import React from "react";
import "./AddingLightLoader.css";

const AddingLightLoader = () => {
  return (
    <div className="dot-spinner" role="status" aria-label="Loading">
      <div className="dot-spinner__dot"></div>
      <div className="dot-spinner__dot"></div>
      <div className="dot-spinner__dot"></div>
      <div className="dot-spinner__dot"></div>
      <div className="dot-spinner__dot"></div>
      <div className="dot-spinner__dot"></div>
      <div className="dot-spinner__dot"></div>
      <div className="dot-spinner__dot"></div>
    </div>
  );
};

export default AddingLightLoader;
